import { render } from "./ContentIncludeView.vue?vue&type=template&id=5dd88568"
import script from "./ContentIncludeView.vue?vue&type=script&lang=js"
export * from "./ContentIncludeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__